import { useEffect, useRef } from "react";
import { startBricks, ThemeKey } from "./bricks";

function BrickCanvas({ theme }: { theme: ThemeKey }) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    return startBricks(ref.current, theme);
  }, [theme]);

  return <canvas ref={ref} className="bricks" />;
}

export default BrickCanvas;
